"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function boolToValue(a) {
    return a ? 'true' : 'false';
}
exports.default = boolToValue;
